import React, { memo } from "react";
import classes from "./SyncButton.scss";
import { useTranslation } from "react-i18next";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { ReloadArrowOutlined } from "@toddle-edu/ds-icons";

const SyncButton = ({ isSyncing, onSyncClick, testId }) => {
  const { t } = useTranslation();

  return (
    <Tooltip tooltip={t("transcript:sync_from_toddle")} showArrow>
      <IconButton
        variant="neutral"
        type="outlined"
        size="small"
        icon={
          <ReloadArrowOutlined className={isSyncing ? classes.spinning : ""} />
        }
        disabled={isSyncing}
        onClick={onSyncClick}
        testId={testId}
      />
    </Tooltip>
  );
};

export default memo(SyncButton);
